import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => setMobileOpen(false), [location]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/love', label: '分类' },
    { to: '/about', label: '关于我们' },
  ];

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-transparent'}`}>
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="text-2xl font-bold tracking-tight" style={{ fontFamily: 'var(--font-heading)' }}>
              <span className={scrolled ? 'text-foreground-950' : 'text-white'}>韩漫</span>
              <span className={scrolled ? 'text-rose-500' : 'text-rose-300'}>星球</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 ${isActive(link.to) ? (scrolled ? 'text-rose-500' : 'text-rose-300') : (scrolled ? 'text-foreground-700 hover:text-foreground-950' : 'text-white/80 hover:text-white')}`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className={`relative ${scrolled ? '' : 'text-white'}`}>
              <input
                type="text"
                placeholder="搜索漫画..."
                className={`pl-9 pr-4 py-2 rounded-full text-sm outline-none border transition-all duration-200 w-48 focus:w-64 ${scrolled ? 'bg-background-100 border-background-200 text-foreground-900 placeholder:text-foreground-400' : 'bg-white/15 border-white/20 text-white placeholder:text-white/50'}`}
              />
              <i className={`ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm ${scrolled ? 'text-foreground-400' : 'text-white/60'}`} />
            </div>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center ${scrolled ? 'text-foreground-950' : 'text-white'}`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-background-200 shadow-lg">
          <div className="px-4 py-4 space-y-3">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`block py-2 text-sm font-medium ${isActive(link.to) ? 'text-rose-500' : 'text-foreground-700'}`}
              >
                {link.label}
              </Link>
            ))}
            <div className="pt-2">
              <input
                type="text"
                placeholder="搜索漫画..."
                className="w-full pl-9 pr-4 py-2 rounded-full text-sm outline-none border border-background-200 bg-background-100 text-foreground-900 placeholder:text-foreground-400"
              />
              <i className="ri-search-line absolute -mt-8 ml-3 text-foreground-400 text-sm" />
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}